import { Button } from "@meiden-connect/ui";
import { loadCanvasThumbnail } from "../../lib/canvas-thumbnail-cache";
import { navigate } from "../../router";

interface Props {
  readonly canvasId: string;
  readonly title: string;
  readonly updatedAt: string;
  readonly thumbnailUrl?: string | undefined;
}

export function RecentCanvasCard({ canvasId, title, updatedAt, thumbnailUrl }: Props): JSX.Element {
  const cachedThumbnail = loadCanvasThumbnail(canvasId);
  const coverUrl = cachedThumbnail ?? thumbnailUrl;

  return (
    <Button
      type="button"
      variant="action"
      onClick={() => navigate(`/c/${canvasId}`)}
      className="recent-canvas-card"
    >
      <span
        className="recent-canvas-cover"
        style={coverUrl ? { backgroundImage: `url(${coverUrl})` } : undefined}
      />
      <span className="recent-canvas-body">
        <strong>{title}</strong>
        <span>{updatedAt}</span>
      </span>
    </Button>
  );
}
